export default "__VITE_ASSET__Cdw4AYRk__"